export const isToLCampaignLIFF = () =>
  window.liff.id === process.env.REACT_APP_TOL_CAMPAIGN_LIFF_ID
